import { useState } from 'react';
import { ActionIcon, Anchor, Badge, Indicator, Popover, Stack, Tooltip } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconClock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useAttendance, useLiveTotals } from '../../hooks/useAttendance';
import { STATE_COLOR, formatMinutes, statusSentence } from '../../lib/attendance';
import { AttendancePunchPanel } from './AttendancePunchPanel';

/**
 * Kopfzeile: Stempelstatus mit laufender Zeit (v1.405.0). Klick öffnet die Knöpfe — am Handy ein
 * Symbol mit Farbpunkt (grün arbeitet, gelb Pause, grau weg).
 */
export function AttendanceHeaderButton() {
  const isMobile = useMediaQuery('(max-width: 48em)');
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const { status, fetchedAt } = useAttendance();
  const totals = useLiveTotals(status, fetchedAt);
  if (!status) return null;

  const color = STATE_COLOR[status.state];
  const label = statusSentence(status.state, status.since);
  const short = status.state === 'OFF'
    ? 'Einstempeln'
    : `${status.state === 'ON_BREAK' ? 'Pause' : 'Arbeit'} ${formatMinutes(totals.workMinutes)}`;

  return (
    <Popover opened={opened} onChange={setOpened} position="bottom-end" width={320} shadow="md" withArrow>
      <Popover.Target>
        <Tooltip label={label} withArrow disabled={opened}>
          {isMobile ? (
            <ActionIcon variant="light" color={color} aria-label={`Stempeln — ${label}`} onClick={() => setOpened((o) => !o)}>
              <Indicator color={color} size={8} offset={2} processing={status.state === 'WORKING'}>
                <IconClock size={16} />
              </Indicator>
            </ActionIcon>
          ) : (
            <Badge
              color={color}
              variant={status.state === 'OFF' ? 'outline' : 'light'}
              leftSection={<IconClock size={12} />}
              style={{ cursor: 'pointer' }}
              onClick={() => setOpened((o) => !o)}
            >
              {short}
            </Badge>
          )}
        </Tooltip>
      </Popover.Target>
      <Popover.Dropdown>
        <Stack gap="sm">
          <AttendancePunchPanel />
          <Anchor
            size="xs"
            onClick={() => {
              setOpened(false);
              navigate('/anwesenheit');
            }}
          >
            Team jetzt →
          </Anchor>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
}
